<template>
  <div>
    <h2>Submitted Manuscripts</h2>

    <v-data-table
      :headers="headers"
      :items="folders"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.updatedAt`]="{ item }">
        <small>{{ formatDate(item.updatedAt) }}</small>
      </template>
      <template v-slot:[`item._id`]="{ item }">
        {{ `JMESR/${String(item._id).toUpperCase()}` }}
      </template>
      <template v-slot:[`item.manuscripts[0].manuscriptStatus`]="{ item }">      
        <v-chip pill small class="mr-1 mb-1 mt-1">
          Status:&nbsp;
          <span class="text-uppercase">{{ item.manuscripts[0].manuscriptStatus }}</span>
        </v-chip>

        <v-chip
          small
          v-if="item.manuscripts[0].decision"
          :color="decisionChip(item.manuscripts[0].decision).color"
        >
          Decision: {{ decisionChip(item.manuscripts[0].decision).decision }}&nbsp;
          <v-icon>{{ decisionChip(item.manuscripts[0].decision).icon }}</v-icon>
        </v-chip>
      </template>
      <template v-slot:[`item.__v`]="{ item }">
        <v-menu
          open-on-hover
          small
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark   small
              outlined
              v-bind="attrs"
              v-on="on"
            >
              Actions
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item link :to="`/manuscripts/submitted/track/${item.manuscripts[0]._id}`">
              <v-list-item-title>Track Manuscript</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="(item.manuscripts[0].manuscriptStatus == ManuscriptStatus.minorRevision ||
                  item.manuscripts[0].manuscriptStatus == ManuscriptStatus.majorRevision ||
                  item.manuscripts[0].manuscriptStatus == ManuscriptStatus.resubmissionRequested)" @click="reviseManuscript(item.manuscripts[0]._id)">
              <v-list-item-title>Submit Revision</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { formatDate } from "../../tools/format";
import { decisionChip } from "../../tools/decision-chip";

import { manuscriptStatus as ManuscriptStatus } from "../../tools/manuscript";

export default {
  data: () => ({
    loading: false,
    deleting: false,
    revising: false,
    folders: [],
    headers: [
      { text: "Updated", value: "updatedAt" },
      { text: "Manuscript ID", value: "_id" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "manuscripts[0].title",
      },
      {
        text: "Status",
        align: "start",
        value: "manuscripts[0].manuscriptStatus",
      },
      { text: "Actions", value: "__v", sortable: false },
    ],
    ManuscriptStatus
  }),
  methods: {
    formatDate,
    decisionChip,
    fetchSubmissions() {
      this.loading = true;
      this.$axios
        .get("/manuscripts")
        .then(({ data: response }) => {
          this.folders = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve manuscripts",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteManuscript(id) {
      this.deleting = true;

      this.$axios
        .delete(`/manuscript/${id}`)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Manuscript deleted",
          });
          this.fetchSubmissions();
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not delete manuscript",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    reviseManuscript(manuscript) {
      if (manuscript && !this.revising) {
        this.revising = true;
        this.$axios
          .post(`/manuscript/revise`, { manuscript })
          .then(({ data: response }) => {
            this.$bus.$emit("manuscript.refresh");

            this.$router.push({
              path: `/manuscripts/continue/${response._id}`,
            });

            this.$bus.$emit("snackbar", {
              type: "info",
              message: "Please continue revision",
            });
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not start revision",
            });
          })
          .finally(() => {
            this.revising = false;
          });
      }
    },
  },
  mounted() {
    this.fetchSubmissions();
  },
};
</script>
